// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 360) return "static/chunks/4a9814ee-e004f4af232e42fd.js";
	if (chunkId === 8179) return "static/chunks/8179-959641b74a3c07cb.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9701 ? "04763798" : chunkId) + "." + {"2269":"724a8f9f2dedb70d","4452":"8b1cac0a7309c523","5408":"e2806620dbc79b35","6367":"bab65ace3ba492d1","6743":"c9f57f3f035e3534","9701":"2c1c0349a4e7e808"}[chunkId] + ".js";
};